<template>
  <section>
    <SideLeft :status="leftSideStatus">
      <div>
        <h6
          class="
            tx-uppercase tx-12 tx-mont tx-spacing-1
            mg-t-10
            pd-x-10
            tx-white-7
          "
        >
          {{ $t("dashboard.筛选条件") }}
        </h6>
        <div class="form-group mg-b-10">
          <select
            class="form-control form-control-dark select2"
            v-model="filterProps.type"
            @change="filtrate"
          >
            <option value="">{{ $t("dashboard.选择公告类型") }}</option>
            <option v-for="(type, k) in noticeTypeArr" :key="k" :value="k">
              {{ $t(type) }}
            </option>
          </select>
        </div>
        <div class="mg-b-20 form-group">
          <div class="datepicker-group">
            <div class="input-group mg-b-1">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                data-id="datepicker-from"
                type="text"
                class="form-control-dark form-control fc-datepicker"
                id="timePublishedFrom"
                :placeholder="$t('dashboard.起始日期')"
                @keyup.enter="filtrate"
              />
            </div>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                data-id="datepicker-to"
                type="text"
                class="form-control form-control-dark fc-datepicker"
                id="timePublishedTo"
                :placeholder="$t('dashboard.截止日期')"
                @keyup.enter="filtrate"
              />
            </div>
          </div>
        </div>
      </div>
      <button
        class="
          btn btn-primary btn-block
          tx-uppercase tx-11 tx-spacing-2 tx-medium
        "
        @click="filtrate"
      >
        {{ $t("dashboard.筛 选") }}
      </button>
    </SideLeft>
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header>
        <template slot="row-1">
          <div class="d-flex align-items-center mg-b-15">
            <i class="icon ion-ios-paper"></i>
            <div class="mg-l-20">
              <h4>{{ $t("dashboard.公告栏") }}</h4>
            </div>
          </div>
          <div class="tx-right"></div>
        </template>
        <template slot="clearKey">
          <a
            v-show="filterProps.type"
            @click="clearKey('type')"
            href="javascript:;"
            class="mg-r-15"
          >
            {{ $t("dashboard.公告类型：") }}
            <span class="mg-r-10">{{
              $t(noticeTypeArr[filterProps.type])
            }}</span>
            <i class="fa fa-close"></i>
          </a>
          <a
            v-show="
              filterProps.timePublishedFrom || filterProps.timePublishedTo
            "
            @click="clearKey('timePublished')"
            href="javascript:;"
            class="mg-r-15"
          >
            {{ $t("dashboard.发布日期：") }}
            <span class="mg-r-10"
              >{{ filterProps.timePublishedFrom }} {{ $t("dashboard.至") }}
              {{ filterProps.timePublishedTo }}</span
            >
            <i class="fa fa-close"></i>
          </a>
        </template>
      </Header>
      <router-view
        :first_loading="firstLoading"
        :noticeTypeArr="noticeTypeArr"
        :items="items"
        @openNoticeView="openNoticeView"
      />
      <Pagination
        class="pd-x-20 pd-sm-x-30"
        v-if="!firstLoading"
        :cur="page"
        :all="totalPage"
        :path="'/notice/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      />
      <ModalNoticeView :item="modelItem" :noticeTypeArr="noticeTypeArr" />
      <api-loading :show="loading"></api-loading>
    </div>
  </section>
</template>

<script>
import { pagination } from "@components/pagination.js"; //分页
import SideLeft from "@components/left-side.vue";
import Header from "@components/header.vue";
import ModalNoticeView from "./modal-notice-view.vue";

export default {
  components: {
    SideLeft,
    Header,
    Pagination: pagination,
    ModalNoticeView,
  },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: true,
      firstLoading: true,
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("notice-rowsPerPage"))
        ? parseInt(store.get("notice-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      items: [],
      modelItem: {},
      noticeTypeArr: arrDict.noticeType,
      filterProps: {
        type: "",
        timePublishedFrom: "",
        timePublishedTo: "",
      },
    };
  },
  methods: {
    changeLeftSideStatus() {
      //改变左边栏状态
      this.leftSideStatus = !this.leftSideStatus;
      store.set("leftSideStatus", this.leftSideStatus);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: `${this.$route.meta.url}/1` });
      if (page == 1) {
        this.getList();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: `${this.$route.meta.url}/${num}` });
      if (page == num) {
        this.getList();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        type: this.filterProps.type,
        timePublishedFrom: this.filterProps.timePublishedFrom,
        timePublishedTo: this.filterProps.timePublishedTo,
      };
      $.api_call("api.Announcement.getAnnouncementList", params, (r) => {
        this.loading = false;
        this.firstLoading = false;
        if (r.ErrorCode == "9999") {
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    openNoticeView(item) {
      this.modelItem = item;
      $("#modalNoticeView").modal("show");
    },
    datepickerSelect() {
      $("[data-id=datepicker-from]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-to]"))
              .datepicker("option", "minDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            // document.getElementById('timePublishedFrom').value = selectedDate;
          },
        });
      });
      $("[data-id=datepicker-to]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-from]"))
              .datepicker("option", "maxDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            // document.getElementById('timePublishedTo').value = selectedDate;
          },
        });
      });
    },
    filtrate() {
      this.filterProps.timePublishedFrom =
        document.getElementById("timePublishedFrom").value;
      this.filterProps.timePublishedTo =
        document.getElementById("timePublishedTo").value;
      this.toPage(1);
    },
    clearKey(type) {
      if (type == "timePublished") {
        this.filterProps.timePublishedFrom = this.filterProps.timePublishedTo =
          "";
        document.getElementById("timePublishedFrom").value =
          document.getElementById("timePublishedTo").value = "";
        $("[data-id=datepicker-from],[data-id=datepicker-to]").datepicker(
          "destroy"
        );
        this.datepickerSelect();
      } else {
        this.filterProps[type] = "";
      }
      this.toPage(1);
    },
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("notice-rowsPerPage", this.rowsPerPage);
    },
    filterProps: {
      handler: function () {
        this.datepickerSelect();
      },
      deep: true,
    },
  },
  mounted() {
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "transfer.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("transfer.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("transfer.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
        });
      }
    }
    this.getList();
    this.datepickerSelect();
  },
};
</script>

